import axios from '@/utils/request';

// 获取我的调查问卷列表
export const getMyQsts = (data: any) => {
  return axios.request({
    url: 'Questionnaire/GetMyQsts',
    method: 'GET',
    params: data,
  });
};

// 获取问卷题目
export const getQst = (data: any) => {
  return axios.request({
    url: 'Questionnaire/GetQst',
    method: 'GET',
    params: data,
  });
};

// 提交问卷作答
export const postQstAnswer = (data: any) => {
  return axios.request({
    url: 'Questionnaire/PostQstAnswer',
    method: 'POST',
    data,
  });
};
